import React from 'react';
import classnames from 'classnames';
import { Text } from '@leverege/ui-elements';
import { FontModel } from '@leverege/ui-style-elements';
import Attributes from "../../attribute/Attributes.js";
import S from './DetailHeader.css';

// Ideally, this would just use Detail Renderers

/**
 * This is the header for a Card
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DetailHeader(props) {
  const {
    header,
    headerControls,
    target,
    context,
    variant
  } = props;
  const {
    icon,
    primary
  } = header;
  const iconSize = icon?.size || '24px';
  const primAttr = primary?.attrName ? Attributes.get(primary.attrName, target, context) : null;
  const iconAttr = icon?.attrName ? Attributes.get(icon.attrName, target, context) : null;
  let iconView = null;
  if (typeof iconAttr === 'string') {
    if (iconAttr[0] === '/' || iconAttr[0] === '.' || iconAttr.startsWith('http:') || iconAttr.startsWith('https:') || iconAttr.startsWith('data:')) {
      const style = {
        width: iconSize,
        height: iconSize,
        backgroundImage: `url(${iconAttr})`,
        backgroundSize: 'cover'
      };
      iconView = /*#__PURE__*/_jsx("div", {
        style: style,
        className: S.icon
      });
    } else {
      // image icon
      iconView = /*#__PURE__*/_jsx("i", {
        style: {
          fontSize: iconSize
        },
        className: classnames(iconAttr, S.icon)
      });
    }
  }
  const ps = FontModel.toCss(primary.font);
  if (primary.color) {
    ps.color = primary.color;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(S.header, iconView && S.hasIcon, headerControls && S.hasControls),
    children: [iconView, /*#__PURE__*/_jsx(Text, {
      variant: variant,
      className: S.primary,
      style: ps,
      children: primAttr || '---'
    }), headerControls != null && /*#__PURE__*/_jsx("div", {
      className: S.controls,
      children: headerControls
    })]
  });
}